import { Segment } from '~src/interfaces/segment.interface';
import { CustomCycle, CycleStatus, NewCustomCycle } from './cycle.interface';

export interface ScheduleI {
  about: Segment[];
  active: boolean;
  anonymityMinAnswers?: number;
  anonymous: boolean;
  ask: Segment[];
  askManagersOfAbouts: boolean;
  askManagersOfAsks: boolean;
  askTeamMembersOfAsks: boolean;
  askTeamMembersOfAbouts: boolean;
  attributesVisibility: boolean;
  createdAt?: string;
  createdBy?: string;
  dueDate: string | null;
  id: string;
  customSelectors: Segment[];
  managersSelection: boolean;
  managersSelectionMail: boolean;
  overdueAnswers: boolean;
  reminder: number | null;
  reminderMail: boolean;
  repetition: number | null;
  repetitionMail: boolean;
  selfAssessment: boolean;
  selfSelection: boolean;
  selfSelectionMail: boolean;
  share: Segment[];
  /** @deprecated */
  shareWithManagers: boolean;
  shareWithManagersLevels: number;
  shareWithSubject: boolean;
  showInHeatmapToprow: boolean;
  startDate: string | null;
  startMail: boolean;
  surveyId: string;
  title: string | null;
  updatedAt?: string;
  updatedBy?: string;
  wasStarted: boolean;
  isAnonymousManagerAnswerVisible: boolean;
  customCycles?: Array<CustomCycle | NewCustomCycle>;
  cyclesToDelete?: string[];
}

export type CreateScheduleI = Partial<Omit<ScheduleUpdate, 'id'>>

export enum SchedulePeriods {
  OpenEnded = 'openEnded',
  DeadLine = 'deadline',
  Repeated = 'repeated',
  Custom = 'custom',
}

export interface ScheduleUpdate {
  about: string[];
  active: boolean;
  anonymityMinAnswers?: number;
  anonymous: boolean;
  ask: string[];
  askManagersOfAbouts: boolean;
  askManagersOfAsks: boolean;
  askTeamMembersOfAsks: boolean;
  askTeamMembersOfAbouts: boolean;
  attributesVisibility: boolean;
  createdAt?: string;
  createdBy?: string;
  dueDate: string | null;
  id: string;
  customSelectors: string[];
  managersSelection: boolean;
  managersSelectionMail: boolean;
  overdueAnswers: boolean;
  reminder: number | null;
  reminderMail: boolean;
  repetition: number | null;
  repetitionMail: boolean;
  selfAssessment: boolean;
  selfSelection: boolean;
  selfSelectionMail: boolean;
  share: string[];
  /** @deprecated */
  shareWithManagers: boolean;
  shareWithManagersLevels:  number;
  shareWithSubject: boolean;
  showInHeatmapToprow: boolean;
  startDate: string | null;
  startMail: boolean;
  surveyId: string;
  title: string | null;
  updatedAt?: string;
  updatedBy?: string;
  wasStarted: boolean;
  isAnonymousManagerAnswerVisible: boolean;
  customCycles?: Array<CustomCycle | NewCustomCycle>;
  cyclesToDelete?: string[];
}

export const getScheduleStartDate = (schedule: ScheduleI) => {
  if (!schedule.customCycles) {
    return schedule.startDate;
  }

  return schedule.customCycles
    .filter((c) => c.cycleStatus === CycleStatus.Scheduled || c.cycleStatus === CycleStatus.Active)
    .sort((a, b) => a.startDate.localeCompare(b.startDate))
    .shift()?.
    startDate || null;
};
